// This is for expanded collapsible tabs on pages. It uses the General Information Section > Collapsible Tabs

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.info-collap-tab-btn').forEach(function(tabBtn) {
      tabBtn.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !isExpanded);

        const content = this.nextElementSibling;
        content.classList.toggle('visible-info');
      });
    });
  });

